import React from 'react';
import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';


interface ErrorModalProps {
  message: string;
  validationErrors?: Record<string, string[]> | null;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ message, validationErrors, onClose }) => {
  return (
    <Dialog open={true} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black bg-opacity-50" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="bg-white rounded-xl p-6 max-w-sm w-full">
          <div className="flex items-center justify-between mb-4">
            <Dialog.Title className="text-black font-semibold text-md">
              Sorry
            </Dialog.Title>
            <button
              onClick={onClose}
              className="text-text-disabled hover:text-black"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>

          <Dialog.Description className="text-black text-md mb-6">
            <p className="mb-4" dangerouslySetInnerHTML={{ __html: message }} />

            {validationErrors && Object.keys(validationErrors).length > 0 && (
              <div className="mt-4">
                <ul className="list-disc list-inside space-y-1 text-sm">
                  {Object.values(validationErrors).flat().map((error, index) => (
                    <li key={index} className="text-red-600">
                      {error}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </Dialog.Description>

          <button
            onClick={onClose}
            className="btn-primary w-full"
          >
            OK
          </button>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default ErrorModal; 